import { motion, type MotionProps } from "framer-motion";
import type { HTMLAttributes } from "react";
import { cn } from "@/shared/lib/cn";

export type DividerProps = HTMLAttributes<HTMLHRElement> & MotionProps;

export const Divider = ({ className, children, ...props }: DividerProps) => (
	<motion.hr className={cn("w-[2px] h-[2px] bg-divider", className)} {...props} />
);
